
import { computed, defineComponent, ref, Ref, watch } from "vue";
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonSearchbar,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonButton,
  IonInput,
  IonImg,
} from "@ionic/vue";
import { useStore } from "@/store";
import { ACTIONS } from "../store";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { Story } from "@/data/game";
import { getImg } from "@/data/story";


export default defineComponent({
  components: {
    IonContent,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuButton,
    IonSearchbar,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonButton,
    IonInput,
    IonImg,
  },
  name: "MarketPlace",
  setup() {
    const store = useStore();
    const router = useRouter();

    // setup localized messages
    const { t, locale, mergeLocaleMessage } = useI18n();
    const localeMajor = locale.value.substring(0, 2);
    mergeLocaleMessage("en", {
      story: {
        title: "Join an adventure!",
        enterCode: "Enter your party code",
        placeholder: "Got a party code?",
        join: "Join Party",
        dinnerCodeError: "unknown code",
      },
    });
    mergeLocaleMessage("de", {
      story: {
        title: "Nimm an einem Spiel Teil!",
        enterCode: "Gib Deinen Code ein",
        placeholder: "Hast Du einen Party Code?",
        join: "Nimm teil",
        dinnerCodeError: "unbekannter code",
      },
    });

    // set Locale
    store.dispatch(ACTIONS.SET_LOCALE, localeMajor);
    const stories: Ref<Story[]> = ref(store.state.stories);
    if (store.state.stories.length == 0) {
      store
        .dispatch(ACTIONS.GET_STORIES)
        .then((result) => (stories.value = result))
        .catch((error) => console.log(error));
    }
    const searchString: Ref<string> = ref("");
    const filteredStories = computed(() =>
      stories.value.filter((item) =>
        item.name.toLowerCase().includes(searchString.value.toLowerCase())
      )
    );
    const dinnerCode = ref("");
    const dinnerCodeError = ref("");
    watch(dinnerCode, () => (dinnerCodeError.value = ""));
    
    const joinDinner = () => {
      store
        .dispatch(ACTIONS.SET_STATE_ID, dinnerCode.value)
        .then(() => {
          dinnerCodeError.value = "";
          router.push("/story");
        })
        .catch((error) => {
          dinnerCodeError.value = t("story.dinnerCodeError");
        });
    };
    return {
      filteredStories,
      searchString,
      t,
      locale,
      store,
      dinnerCode,
      dinnerCodeError,
      joinDinner,
      getImg,
    };
  },
});
